import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * Single boolean checkbox. For lists of checkboxes use `kt-checkbox-group`
 * (array-valued); this primitive is for standalone true/false flags
 * ("Show deactivated", "I agree", …).
 */
@Component({
  selector: 'kt-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true }]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() hint = '';
  @Input() tooltip = '';
  @Input() errorMessage = '';
  @Input() disabled = false;
  @Input() required = false;
  @Input() set checked(v: boolean) { this.value = !!v; }
  get checked(): boolean { return this.value; }
  @Input() indeterminate = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  value = false;

  onChange = (_: any) => { };
  onTouched = () => { };

  onCheckChange(checked: boolean) {
    this.value = checked;
    this.onChange(checked);
    this.onTouched();
    this.checkedChange.emit(checked);
  }

  writeValue(value: any) { this.value = !!value; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
